import { Injector, Component, OnInit } from '@angular/core';
import { isEmpty, find } from 'lodash';
import { LinkExpirationServie } from '../../../Services/link-expiration/link-expiration';
import { LayoutService } from '../../../Services/layout/layout.service';
import * as bowser from 'bowser';
import { Subscription } from 'rxjs';
import { ActionApiService } from 'src/app/Services/action-api/action-api.service';
import { EventsComponent } from '../events/events.component';
import { take } from 'rxjs/operators';
import { InformationModalService } from 'src/app/Services/information-model-factory/information-model-factory';
import { UnderWrittenComponent } from '../under-written/under-written.component';

@Component({
	selector: 'QuoteWithInfoProvider',
	templateUrl: './quote-with-provider-info.component.html',
	styleUrls: ['./quote-with-provider-info.component.scss'],
})
export class QuoteWithInfoProviderComponent extends EventsComponent implements OnInit {
	selectedOption: any;
	dialNumber: any;
	bowser: any;
	showQuote: boolean;
	rateClass: string;
	buyClass: string;
	insurerSelectedSubscription: Subscription;
	shouldShowCallMeNow: boolean = false;
	model: any;
	finishButtonToCustomizeFlag: boolean = false;
	isCovModFlagOn: boolean = false;
	isAgentFlowType: boolean = false;
	isCustomizable: boolean = false;
	showFYIMessage: boolean = false;
	isCallPAAFlagOn: boolean = false;
	shouldShowCallPaa: boolean = false;

	constructor(
		injector: Injector,
		private actionApiService: ActionApiService,
		private LayoutService: LayoutService,
		private linkExpiration: LinkExpirationServie,
		private informationModalService: InformationModalService
	) {
		super(injector);
	}

	ngOnInit() {
		this.selectedOption = this.getSelection();
		this.rateClass = this.getRateClass();
		this.buyClass = this.getBuyClass();
		this.bowser = bowser;
		if (this.selectedOption && this.selectedOption.buyButton) {
			this.linkExpiration.setLinkExpiration(this.selectedOption.buyButton.attributes.ReQuotedData);
		}

		this.LayoutService.staticLayout.subscribe((data) => {
			if (data && data.data && data.data.globalAttributes && data.data.metadata.page.stage == 'YourRates') {
				this.model = data.data;
				data.data.globalAttributes.shouldShowCallMeButtonBottom =
					!!data.data.globalAttributes.shouldShowCallMeNow && this.selectedOption.type !== 'unavailable';
				this.shouldShowCallMeNow = !!data.data.globalAttributes.shouldShowCallMeNow;
				this.showFYIMessage = this.isCovModCarrierSeen();
				const carrierInfo = this.storeService.getValue('CarrierInformation', this.context);
				this.isCustomizable = carrierInfo != null ? carrierInfo.isCustomizable : this.isCustomizable;
			}
		});

		this.layoutService.globalAttributes.subscribe((data) => {
			if (data) {
				this.finishButtonToCustomizeFlag = data['finishButtonToCustomize'];
				this.isCovModFlagOn = data['covModFlag'];
				this.isAgentFlowType = data['flowType'] == 'Agent';
				this.isCallPAAFlagOn = data['call-paa-message-pilot'];
				this.shouldShowCallPaa = this.shouldShowCallPAA();
			}
		});

		this.insurerSelectedSubscription = this.observablesService.insurerSelected.subscribe(() => {
			this.selectedOption = this.getSelection();
			if (this.selectedOption && this.selectedOption.buyButton) {
				this.linkExpiration.setLinkExpiration(this.selectedOption.buyButton.attributes.ReQuotedData);
			}
			this.rateClass = this.getRateClass();
			this.buyClass = this.getBuyClass();
		});

		setTimeout(() => {
			const elementId = 'underwritten';
			if (document.getElementById(elementId)) {
				const elem: any = document.getElementById(elementId).querySelector('a.underwritten-link');
				if (elem) {
					this.Renderer.setAttribute(elem, 'tabindex', '0');

					elem.addEventListener(['click'], () => {
						var isOpen = this.informationModalService.isModelOpen();
						if (!isOpen) {
							this.informationModalService.open({
								data: {
									proglogo: this.control.attributes.proglogo,
									imageSrc: this.selectedOption.imgUrl,
									expandedText: this.selectedOption.expandedText,
									carrierName: this.selectedOption.name,
								},
								windowClass: '',
								componentType: UnderWrittenComponent,
							});
						}
					});
					elem.addEventListener(['keydown'], (event) => {
						if (event.key == 'Enter') {
							var isOpen = this.informationModalService.isModelOpen();
							if (!isOpen) {
								this.informationModalService.open({
									data: {
										proglogo: this.control.attributes.proglogo,
										imageSrc: this.selectedOption.imgUrl,
										expandedText: this.selectedOption.expandedText,
										carrierName: this.selectedOption.name,
									},
									windowClass: '',
									componentType: UnderWrittenComponent,
								});
							}
						} else {
							return false;
						}
					});
					elem.addEventListener(['touch'], () => {
						var isOpen = this.informationModalService.isModelOpen();
						if (!isOpen) {
							this.informationModalService.open({
								data: {
									proglogo: this.control.attributes.proglogo,
									imageSrc: this.selectedOption.imgUrl,
									expandedText: this.selectedOption.expandedText,
									carrierName: this.selectedOption.name,
								},
								windowClass: '',
								componentType: UnderWrittenComponent,
							});
						}
					});
					elem.addEventListener(['touchstart'], () => {
						var isOpen = this.informationModalService.isModelOpen();
						if (!isOpen) {
							this.informationModalService.open({
								data: {
									proglogo: this.control.attributes.proglogo,
									imageSrc: this.selectedOption.imgUrl,
									expandedText: this.selectedOption.expandedText,
									carrierName: this.selectedOption.name,
								},
								windowClass: '',
								componentType: UnderWrittenComponent,
							});
						}
					});
				}
			}
		}, 0);
	}

	isCovModCarrierSeen() {
		return this.control.attributes.alertBox && this.control.attributes.alertBox.seenCovModCarrier
			? true
			: this.carrierInformationService.isCovModCarrierSeen;
	}

	get yearly() {
		return this.selectedOption && this.selectedOption.year.split('.');
	}

	getSelection() {
		const bowserType = bowser.getParser(window.navigator.userAgent).getPlatformType();
		this.dialNumber = 'tel:' + this.control.attributes.phoneNum;

		let selected = this.storeService.getValue('CarrierInformation', this.context);
		this.showQuote = !selected.hasPackage;

		return find(this.control.attributes.options, { name: selected.name });
	}

	setHref() {
		return this.control.disabled
			? ''
			: !isEmpty(this.selectedOption.buyButton.attributes.url)
			? this.selectedOption.buyButton.attributes.url
			: '';
	}

	hasUrl() {
		return !isEmpty(this.selectedOption.buyButton.attributes.url);
	}

	setMobileLabel() {
		return !isEmpty(this.selectedOption.buyButton.attributes.mobilelabel)
			? this.selectedOption.buyButton.attributes.mobilelabel
			: this.selectedOption.buyButton.attributes.label;
	}

	buyButtonClick() {
		if (
			!this.linkExpiration.validateLinkExpiration(
				this.selectedOption.buyButton.ajaxInfo,
				this.selectedOption.buyButton.attributes.ReQuotedData
			)
		) {
			this.selectedOption.buyButton.attributes.url = '';
		}
		this.control.ajaxInfo = this.selectedOption.buyButton.ajaxInfo;
		this.value = this.storeService.getValue('CarrierInformation', this.context);
		this.actionService.ajaxAction(this.control.ajaxInfo, this.context);
	}

	callMeNowClick() {
		let carrierInfo = this.storeService.getValue('CarrierInformation', this.context);
		const newObject = {};
		Object.keys(carrierInfo).forEach((oldKey) => {
			delete Object.assign(newObject, carrierInfo, { ['CarrierInformation.' + oldKey]: newObject[oldKey] })[oldKey];
		});
		const requestBody: request = {
			data: newObject,
			info: {
				action: 'TalkWithUs',
				conditions: '',
				elementSrc: 'show_brick',
				stage: 'Enter_Phone_1',
				notRenderPage: false,
			},
			isRemoteAction: true,
		};
		this.actionApiService.invokeAction(requestBody);
	}

	isMObile() {
		return bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile';
	}

	getRateClass() {
		let type = this._isBuyOnlineOrAvailable();
		if (type) {
			return `${type}-rate-small`;
		}
		return '';
	}

	getBuyClass() {
		let type = this._isBuyOnlineOrAvailable();
		if (type) {
			return `${type}-buy-small`;
		}
		return '';
	}

	_isBuyOnlineOrAvailable() {
		let val;
		switch (this.selectedOption.type) {
			case 'buyOnline':
				val = 'buyOnline';
				break;
			case 'unavailable':
				val = 'unavailable';
				break;
			case 'available':
				val = 'available';
				break;
			default:
				val = false;
				break;
		}
		return val;
	}

	buyClicked() {
		let target = this.selectedOption.buyButton.attributes.flowType == 'Consumer' ? '_self' : '_blank';
		let location = this.control.disabled ? '' : this.setHref();
		!this.control.disabled &&
			(!this.hasUrl() || this.selectedOption.buyButton.attributes.mixaction) &&
			this.buyButtonClick();
		location = this.control.disabled ? '' : this.setHref();
		// FIX for safari wait until ajaxAction finished
		// this.observablesService.preBridgeCall = new Subject<any>();
		this.observablesService.preBridgeCall.pipe(take(1)).subscribe(() => {
			//take(1) so it will open only one window per click, and not as much ajax calls were queued
			!isEmpty(location) && window.open(location, target);
		});
	}

	callNowphoneClick() {}

	phoneClick() {}

	shouldShowCallPAA() {
		return this.isCallPAAFlagOn && this.control.attributes.callPAABox && !this.isCovModFlagOn && !this.isAgentFlowType;
	}

	ngOnDestroy() {
		this.insurerSelectedSubscription.unsubscribe();
	}
}
